<template lang="html">
  <error-page-layout
    color-type="error"
    first-message="Você não tem permissão para acessar esse conteúdo."
    image-name="401.png"
    second-message="Contate o administrador da sua plataforma caso queira receber acesso."
    title="Acesso restrito"
  >
    <v-btn slot="buttons" class="px-7" color="primary" dark @click="redirectToFirstPermission">Voltar</v-btn>
  </error-page-layout>
</template>

<script>
import { mapState } from 'pinia'
import ErrorPageLayout from '@/components/ErrorPageLayout.vue'

import { useStore as mainUseStore } from '@/store'
export default {
  components: {
    ErrorPageLayout,
  },
  computed: {
    ...mapState(mainUseStore, {
      userPermissions: 'getUserPermissions',
    }),
  },
  methods: {
    redirectToFirstPermission() {
      const firstPermission = this.userPermissions.includes('home')

      const parent = this.$router.options.routes.find((route) => {
        if (route.meta && route.meta.pagePermission === firstPermission) return route
        else {
          if (route.children) {
            const children = route.children.find((children) => {
              if (children.meta && children.meta.pagePermission === firstPermission) return children
            })
            return children
          }
        }
      })

      if (parent.children) {
        const children = parent.children.find((children) => {
          return children.meta && children.meta.pagePermission === firstPermission
        })
        this.$router.push(`${parent.path}/${children.path}`).catch(() => {})
      } else {
        this.$router.push(`${parent.path}`).catch(() => {})
      }
    },
  },
}
</script>
